import { useState } from "react";
import { projectAuth } from "../../firebase/config";
import { sendPasswordResetEmail } from "firebase/auth";
import Numetrics from "../../assets/numetrics.svg";
import { Link } from "react-router-dom";
import { useSsoLookup } from "../../hooks/useSsoLookup";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [confirmPasswordReset, setConfirmPasswordReset] = useState(false);
  const { ssoProviderId, checkEmail } = useSsoLookup();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   await sendPasswordResetEmail(projectAuth, email);
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // A district that manages sign-in has no password here to reset — and an
    // unverifiable lookup must not fall through to a reset either, since that
    // would hand an SSO-only account a password.
    const lookup = await checkEmail(email);
    if (lookup.ssoProviderId) return;
    if (lookup.status === "unknown") {
      setError("Could not verify access. Please try again.");
      return;
    }

    try {
      // login
      await sendPasswordResetEmail(projectAuth, email);
      setConfirmPasswordReset(true);
    } catch (err) {
      setError(err.code);
    }
  };

  return (
    <div>
      {confirmPasswordReset === false ? (
        <div>
          <div className="min-h-full flex bg-slate-50 items-center align-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 shadow-lg border-b-2">
              <div className="px-5 pb-12">
                {error}
                <h2 className="mt-6 text-center text-3xl font-extrabold text-zinc-700">
                  password reset
                </h2>
                {error && (
                  <div
                    className="bg-red-50/60 w-full flex flex-row items-center border-l-2 border-red-400 text-red-600 my-4 px-3 py-3 rounded-r-md relative gap-2 font-medium"
                    role="alert"
                  >
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        className="w-6 h-6 text-red-500 row-span-2"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>

                    <span>{error}</span>
                  </div>
                )}
                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                  <input type="hidden" name="remember" defaultValue="true" />
                  <div className="rounded-md -space-y-px">
                    <div>
                      <label htmlFor="email-address" className="sr-only">
                        Email address
                      </label>
                      <input
                        required
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={() => checkEmail(email)}
                        value={email}
                        autoComplete="email"
                        className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                        placeholder="Email address"
                      />
                    </div>

                    {ssoProviderId ? (
                    <div>
                      <p className="mt-12 text-sm text-gray-600">
                        Your district manages your sign-in, so there's no
                        password to reset. Use{" "}
                        <Link
                          className="font-medium text-indigo-600 hover:text-indigo-500"
                          to="/login"
                        >
                          Sign in
                        </Link>{" "}
                        with your district email.
                      </p>
                    </div>
                    ) : (
                    <div>
                      <button
                        type="submit"
                        className="group mt-12 w-[1/2] relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Reset Password
                      </button>
                    </div>
                    )}
                  </div>
                </form>
              </div>
              <div className="bg-white py-4 rounded-b-xl">
                <img
                  className="h-[20px] mx-auto w-auto"
                  src={Numetrics}
                  alt="NuMetrics"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="min-h-full flex bg-slate-50 items-center align-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-lg w-full space-y-8 shadow-lg border-b-2">
            <div className="px-5 pb-12">
              <h2 className="mt-6 text-center text-3xl font-extrabold text-zinc-700">
                success
              </h2>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-[100px] h-[100px] mx-auto text-emerald-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h4 className="mt-2 text-center text-lg text-gray-600">
                A password-reset link has been sent to your email.
              </h4>
              <p className="mt-6 text-center text-sm text-gray-600">
                Need help signing in?{" "}
                <a
                  href="mailto:support@numetrics.org"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  contact support@numetrics.org
                </a>
              </p>
              <Link
                onClick={() => setConfirmPasswordReset(false)}
                to="/login"
                type="submit"
                className="group mt-12 w-full mx-auto relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
